// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file finance/v1/domain.proto (package finance.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { PaymentMethod, PaymentStatus_Status, PaymentTermCode, PaymentType } from "./finance_pb.js";
import { file_finance_v1_finance } from "./finance_pb.js";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Base, ID, Money } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file finance/v1/domain.proto.
 */
export const file_finance_v1_domain: GenFile = /*@__PURE__*/
  fileDesc("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", [file_finance_v1_finance, file_google_protobuf_timestamp, file_types]);

/**
 * Bill messages
 *
 * @generated from message finance.v1.Bill
 */
export type Bill = Message<"finance.v1.Bill"> & {
  /**
   * @generated from field: types.Base base = 1;
   */
  base?: Base;

  /**
   * @generated from field: finance.v1.BillType type = 2;
   */
  type: BillType;

  /**
   * @generated from field: string document_number = 3;
   */
  documentNumber: string;

  /**
   * @generated from field: google.protobuf.Timestamp document_date = 4;
   */
  documentDate?: Timestamp;

  /**
   * @generated from field: types.Money amount = 5;
   */
  amount?: Money;

  /**
   * @generated from field: google.protobuf.Timestamp eligible_at = 6;
   */
  eligibleAt?: Timestamp;

  /**
   * @generated from field: repeated finance.v1.BillComplianceRule compliance = 7;
   */
  compliance: BillComplianceRule[];

  /**
   * @generated from field: finance.v1.BillStatus status = 8;
   */
  status: BillStatus;

  /**
   * @generated from field: string notes = 9;
   */
  notes: string;

  /**
   * @generated from field: finance.v1.PaymentMethod preferred_payment_method = 10;
   */
  preferredPaymentMethod: PaymentMethod;

  /**
   * @generated from field: finance.v1.PaymentTermCode payment_term = 11;
   */
  paymentTerm: PaymentTermCode;

  /**
   * @generated from field: types.ID payment_term_id = 18;
   */
  paymentTermId?: ID;

  /**
   * @generated from field: types.ID scale_ticket_id = 12;
   */
  scaleTicketId?: ID;

  /**
   * @generated from field: types.ID outbound_scale_ticket_id = 13;
   */
  outboundScaleTicketId?: ID;

  /**
   * @generated from field: types.ID facility_id = 14;
   */
  facilityId?: ID;

  /**
   * @generated from field: types.ID account_id = 15;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID creator_id = 16;
   */
  creatorId?: ID;

  /**
   * @generated from field: repeated finance.v1.Payment payments = 17;
   */
  payments: Payment[];
};

/**
 * Describes the message finance.v1.Bill.
 * Use `create(BillSchema)` to create a new message.
 */
export const BillSchema: GenMessage<Bill> = /*@__PURE__*/
  messageDesc(file_finance_v1_domain, 0);

/**
 * @generated from message finance.v1.InvoiceEntityReference
 */
export type InvoiceEntityReference = Message<"finance.v1.InvoiceEntityReference"> & {
  /**
   * @generated from field: finance.v1.InvoiceEntityReferenceType entity_type = 1;
   */
  entityType: InvoiceEntityReferenceType;

  /**
   * @generated from field: types.ID entity_id = 2;
   */
  entityId?: ID;
};

/**
 * Describes the message finance.v1.InvoiceEntityReference.
 * Use `create(InvoiceEntityReferenceSchema)` to create a new message.
 */
export const InvoiceEntityReferenceSchema: GenMessage<InvoiceEntityReference> = /*@__PURE__*/
  messageDesc(file_finance_v1_domain, 1);

/**
 * Invoice messages
 *
 * @generated from message finance.v1.Invoice
 */
export type Invoice = Message<"finance.v1.Invoice"> & {
  /**
   * @generated from field: types.Base base = 1;
   */
  base?: Base;

  /**
   * @generated from field: finance.v1.InvoiceType type = 2;
   */
  type: InvoiceType;

  /**
   * @generated from field: string document_number = 3;
   */
  documentNumber: string;

  /**
   * @generated from field: google.protobuf.Timestamp document_date = 4;
   */
  documentDate?: Timestamp;

  /**
   * @generated from field: types.Money amount = 5;
   */
  amount?: Money;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 6;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: finance.v1.InvoiceStatus status = 7;
   */
  status: InvoiceStatus;

  /**
   * @generated from field: finance.v1.PaymentTermCode payment_term = 8;
   */
  paymentTerm: PaymentTermCode;

  /**
   * @generated from field: types.ID payment_term_id = 15;
   */
  paymentTermId?: ID;

  /**
   * @generated from field: string notes = 9;
   */
  notes: string;

  /**
   * @generated from field: types.ID facility_id = 10;
   */
  facilityId?: ID;

  /**
   * @generated from field: types.ID account_id = 11;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID creator_id = 12;
   */
  creatorId?: ID;

  /**
   * @generated from field: repeated finance.v1.Payment payments = 13;
   */
  payments: Payment[];

  /**
   * @generated from field: repeated finance.v1.InvoiceEntityReference source_references = 14;
   */
  sourceReferences: InvoiceEntityReference[];
};

/**
 * Describes the message finance.v1.Invoice.
 * Use `create(InvoiceSchema)` to create a new message.
 */
export const InvoiceSchema: GenMessage<Invoice> = /*@__PURE__*/
  messageDesc(file_finance_v1_domain, 2);

/**
 * Payment messages
 *
 * @generated from message finance.v1.Payment
 */
export type Payment = Message<"finance.v1.Payment"> & {
  /**
   * @generated from field: types.Base base = 1;
   */
  base?: Base;

  /**
   * @generated from field: string document_number = 2;
   */
  documentNumber: string;

  /**
   * @generated from field: finance.v1.PaymentStatus.Status status = 3;
   */
  status: PaymentStatus_Status;

  /**
   * @generated from field: finance.v1.PaymentType payment_type = 4;
   */
  paymentType: PaymentType;

  /**
   * @generated from field: finance.v1.PaymentMethod payment_method = 5;
   */
  paymentMethod: PaymentMethod;

  /**
   * @generated from field: types.Money amount = 6;
   */
  amount?: Money;

  /**
   * @generated from field: google.protobuf.Timestamp transaction_date = 7;
   */
  transactionDate?: Timestamp;

  /**
   * @generated from field: types.ID check_facility_id = 8;
   */
  checkFacilityId?: ID;

  /**
   * @generated from field: string check_number = 9;
   */
  checkNumber: string;

  /**
   * @generated from field: string check_memo = 10;
   */
  checkMemo: string;

  /**
   * @generated from field: string check_attn = 22;
   */
  checkAttn: string;

  /**
   * @generated from field: string ach_number = 11;
   */
  achNumber: string;

  /**
   * @generated from field: string wire_number = 17;
   */
  wireNumber: string;

  /**
   * @generated from field: string atm_id = 18;
   */
  atmId: string;

  /**
   * @generated from field: string atm_payment_number = 19;
   */
  atmPaymentNumber: string;

  /**
   * @generated from field: string barcode = 20;
   */
  barcode: string;

  /**
   * @generated from field: types.ID supplier_photo_id = 21;
   */
  supplierPhotoId?: ID;

  /**
   * @generated from field: types.ID account_id = 12;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID creator_id = 13;
   */
  creatorId?: ID;

  /**
   * @generated from field: finance.v1.CreatorPlatform creator_platform = 14;
   */
  creatorPlatform: CreatorPlatform;

  /**
   * @generated from field: repeated finance.v1.Bill bills = 15;
   */
  bills: Bill[];

  /**
   * @generated from field: repeated finance.v1.Invoice invoices = 16;
   */
  invoices: Invoice[];
};

/**
 * Describes the message finance.v1.Payment.
 * Use `create(PaymentSchema)` to create a new message.
 */
export const PaymentSchema: GenMessage<Payment> = /*@__PURE__*/
  messageDesc(file_finance_v1_domain, 3);

/**
 * @generated from enum finance.v1.BillType
 */
export enum BillType {
  /**
   * @generated from enum value: BILL_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILL_TYPE_INBOUND = 1;
   */
  INBOUND = 1,

  /**
   * @generated from enum value: BILL_TYPE_OUTBOUND = 2;
   */
  OUTBOUND = 2,

  /**
   * @generated from enum value: BILL_TYPE_FREIGHT = 3;
   */
  FREIGHT = 3,

  /**
   * @generated from enum value: BILL_TYPE_ACCRUAL = 4;
   */
  ACCRUAL = 4,
}

/**
 * Describes the enum finance.v1.BillType.
 */
export const BillTypeSchema: GenEnum<BillType> = /*@__PURE__*/
  enumDesc(file_finance_v1_domain, 0);

/**
 * @generated from enum finance.v1.BillStatus
 */
export enum BillStatus {
  /**
   * @generated from enum value: BILL_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILL_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: BILL_STATUS_PAID = 2;
   */
  PAID = 2,

  /**
   * @generated from enum value: BILL_STATUS_VOIDED = 3;
   */
  VOIDED = 3,
}

/**
 * Describes the enum finance.v1.BillStatus.
 */
export const BillStatusSchema: GenEnum<BillStatus> = /*@__PURE__*/
  enumDesc(file_finance_v1_domain, 1);

/**
 * @generated from enum finance.v1.BillComplianceRule
 */
export enum BillComplianceRule {
  /**
   * @generated from enum value: BILL_COMPLIANCE_RULE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILL_COMPLIANCE_RULE_LEGAL_HOLD = 1;
   */
  LEGAL_HOLD = 1,

  /**
   * @generated from enum value: BILL_COMPLIANCE_RULE_TAX_HOLD = 2;
   */
  TAX_HOLD = 2,
}

/**
 * Describes the enum finance.v1.BillComplianceRule.
 */
export const BillComplianceRuleSchema: GenEnum<BillComplianceRule> = /*@__PURE__*/
  enumDesc(file_finance_v1_domain, 2);

/**
 * @generated from enum finance.v1.InvoiceType
 */
export enum InvoiceType {
  /**
   * @generated from enum value: INVOICE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INVOICE_TYPE_INBOUND = 1;
   */
  INBOUND = 1,

  /**
   * @generated from enum value: INVOICE_TYPE_OUTBOUND = 2;
   */
  OUTBOUND = 2,

  /**
   * @generated from enum value: INVOICE_TYPE_FREIGHT = 3;
   */
  FREIGHT = 3,

  /**
   * @generated from enum value: INVOICE_TYPE_ACCRUAL = 4;
   */
  ACCRUAL = 4,
}

/**
 * Describes the enum finance.v1.InvoiceType.
 */
export const InvoiceTypeSchema: GenEnum<InvoiceType> = /*@__PURE__*/
  enumDesc(file_finance_v1_domain, 3);

/**
 * @generated from enum finance.v1.InvoiceStatus
 */
export enum InvoiceStatus {
  /**
   * @generated from enum value: INVOICE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INVOICE_STATUS_PROFORMA = 1;
   */
  PROFORMA = 1,

  /**
   * @generated from enum value: INVOICE_STATUS_PENDING = 2;
   */
  PENDING = 2,

  /**
   * @generated from enum value: INVOICE_STATUS_PAID = 3;
   */
  PAID = 3,

  /**
   * @generated from enum value: INVOICE_STATUS_VOIDED = 4;
   */
  VOIDED = 4,
}

/**
 * Describes the enum finance.v1.InvoiceStatus.
 */
export const InvoiceStatusSchema: GenEnum<InvoiceStatus> = /*@__PURE__*/
  enumDesc(file_finance_v1_domain, 4);

/**
 * @generated from enum finance.v1.InvoiceEntityReferenceType
 */
export enum InvoiceEntityReferenceType {
  /**
   * @generated from enum value: INVOICE_ENTITY_REFERENCE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INVOICE_ENTITY_REFERENCE_TYPE_OUTBOUND_LOAD = 1;
   */
  OUTBOUND_LOAD = 1,

  /**
   * @generated from enum value: INVOICE_ENTITY_REFERENCE_TYPE_OUTBOUND_LOAD_LINE_ITEM = 2;
   */
  OUTBOUND_LOAD_LINE_ITEM = 2,
}

/**
 * Describes the enum finance.v1.InvoiceEntityReferenceType.
 */
export const InvoiceEntityReferenceTypeSchema: GenEnum<InvoiceEntityReferenceType> = /*@__PURE__*/
  enumDesc(file_finance_v1_domain, 5);

/**
 * @generated from enum finance.v1.CreatorPlatform
 */
export enum CreatorPlatform {
  /**
   * @generated from enum value: CREATOR_PLATFORM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CREATOR_PLATFORM_WEB = 1;
   */
  WEB = 1,

  /**
   * @generated from enum value: CREATOR_PLATFORM_MOBILE = 2;
   */
  MOBILE = 2,

  /**
   * @generated from enum value: CREATOR_PLATFORM_API = 3;
   */
  API = 3,
}

/**
 * Describes the enum finance.v1.CreatorPlatform.
 */
export const CreatorPlatformSchema: GenEnum<CreatorPlatform> = /*@__PURE__*/
  enumDesc(file_finance_v1_domain, 6);

